import { createContext } from 'react';

const JourneyApplicationContext = createContext({
  // For legacy agent assignment component
  agentsOptions: null,
  assignedAgentToken: null,
  assignedAgentLabel: null,

  // For new agent assignment component
  assignableAgents: null,
  assignedAgent: null,
  assignAgent: null,

  currentAgentIsAssigned: false,
  handleChangeAssignedAgent: null,
  handleUnassignAgent: null,
  isAlertInTerminalState: false,
  shouldHighlightNodesWithActionRequired: null,
  setShouldHighlightNodesWithActionRequired: null,
});

export default JourneyApplicationContext;
